import { Pipe, PipeTransform, Injectable } from '@angular/core';
import * as _ from 'lodash';
import { ProductsService } from '../services/products.service';

@Pipe({
  name: 'productsearch',
  pure: false,
})
@Injectable()
export class ProductsearchPipe implements PipeTransform {
  pipevalue: any;
  constructor(public xfilter: ProductsService) {
    this.xfilter.dynamicbrandpipevalue.subscribe(
      (x) => {
        this.pipevalue = x;
      });
  }
  transform(data: any, name: any): any {
    // tslint:disable-next-line:curly
    if (name === undefined) {
      return data;
    } else {
        var stringarr = name.toString().toLowerCase().split(' ');
        var stringlen = stringarr.length;
        var out = [];
        const brandidarray = [];
        const lifestageidarray = [];
        const flavouridarray = [];
        for (let d in data) {
          var rescount = 0;
              for (let i in stringarr) {
                var res = this.checkEveryMatch(data[d].name, stringarr[i])
                var rescount = rescount + res;
              }
              if (rescount === stringlen) {
                out.push(data[d]);
                brandidarray.push(data[d].brand_id);
                lifestageidarray.push(data[d].lifestage_id);
                flavouridarray.push(data[d].flavour_id);
              }
        }
        if (this.pipevalue === 0) {
          const brandresultset = this.getUniquevalue(brandidarray);
          const liferesultset = this.getUniquevalue(lifestageidarray);
          const flavourresultset = this.getUniquevalue(flavouridarray);
          this.xfilter.setDynamicdataset(out);
          this.xfilter.setDynamicbrandset(brandresultset);
          this.xfilter.setDynamiclifestageset(liferesultset);
          this.xfilter.setDynamicflavourset(flavourresultset);
          this.xfilter.dynamicbrandpipe.next(1);
        }
      return out;
      }
  /* return data.filter(function(data){
   return data.name.toString().toLowerCase().includes(name.toString().toLowerCase());
   })
  }*/
}
checkEveryMatch(str, element) {
  if ( str.toString().toLowerCase().match(element)) {
    return 1;
  }else {
    return 0;
  }
}
getUniquevalue(items) {
            // lodash uniqBy function
            return _.uniqBy(items);
        }
}
